import Design from './Design'

export default  {path: '/design', component: Design}
